import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc1cae56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entry_base_contents_wrapper" }
const _hoisted_2 = { class: "entry_base_indicator_wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "entry_base_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_base_title_text" }, "氏名を教えてください")
], -1))
const _hoisted_4 = { class: "entry_base_input" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "氏名"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_6 = { class: "entry_base_input_item_text_column_2" }
const _hoisted_7 = { class: "entry_base_input_item_text_column_2_left" }
const _hoisted_8 = { class: "entry_base_input_item_text_column_2_right" }
const _hoisted_9 = { class: "entry_base_input" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "フリガナ"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_11 = { class: "entry_base_input_item_text_column_2" }
const _hoisted_12 = { class: "entry_base_input_item_text_column_2_left" }
const _hoisted_13 = { class: "entry_base_input_item_text_column_2_right" }
const _hoisted_14 = { class: "entry_base_button" }
const _hoisted_15 = { class: "entry_base_button_prev" }
const _hoisted_16 = { class: "entry_base_button_next" }

import { ref, computed, onMounted, onBeforeMount } from 'vue';
import { useRouter } from 'vue-router';
import { useField, useForm } from 'vee-validate';
import { object, string } from 'yup';
import { getMasterDataList, Master } from '@/api/entryMasterDataEndpoint';
import alertOnReload from '@/utils/alertOnReload';
import store from '@/store';
import Indicator from '@/components/Indicator.vue';
import BaseTextForm from '@/components/BaseTextForm.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseRadioButton from '@/components/BaseRadioButton.vue';
import BaseYmdForm from '@/components/BaseYmdForm.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import VALIDATON_ERRORS from '@/constants/validationErrors';
import * as AutoKana from 'vanilla-autokana';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileView',
  setup(__props) {

const schema = object({
  firstName: string().label('氏名').required(VALIDATON_ERRORS.REQUIRED),
  lastName: string().label('氏名').required(VALIDATON_ERRORS.REQUIRED),
  firstNameKana: string()
    .label('フリガナ')
    .required(VALIDATON_ERRORS.REQUIRED)
    .matches(/^[ァ-ヶー]*$/, VALIDATON_ERRORS.ZEN_KANA),
  lastNameKana: string()
    .label('フリガナ')
    .required(VALIDATON_ERRORS.REQUIRED)
    .matches(/^[ァ-ヶー]*$/, VALIDATON_ERRORS.ZEN_KANA),
});

const { meta, errors } = useForm({
  validationSchema: schema,
});

const { value: firstName } = useField('firstName', undefined, {
  initialValue: store.getters['userRegistration/firstName'],
});
const { value: lastName } = useField('lastName', undefined, {
  initialValue: store.getters['userRegistration/lastName'],
});
const { value: firstNameKana } = useField('firstNameKana', undefined, {
  initialValue: store.getters['userRegistration/firstNameKana'],
});
const { value: lastNameKana } = useField('lastNameKana', undefined, {
  initialValue: store.getters['userRegistration/lastNameKana'],
});
const nameErrors = computed(() => {
  if (errors.value.firstName) {
    return errors.value.firstName;
  }
  if (errors.value.lastName) {
    return errors.value.lastName;
  }
  return '';
});
const nameKanaErrors = computed(() => {
  if (errors.value.firstNameKana) {
    return errors.value.firstNameKana;
  }
  if (errors.value.lastNameKana) {
    return errors.value.lastNameKana;
  }
  return '';
});

let lastNameAutokana: any;
let firstNameAutokana: any;
onMounted(() => {
  lastNameAutokana = AutoKana.bind('#lastName', "#lastNameKana", { katakana: true });
  firstNameAutokana = AutoKana.bind('#firstName', "#firstNameKana", { katakana: true });
});

// 入力時にふりがなを更新
const lastNameInput = () => {
  lastNameKana.value = lastNameAutokana.getFurigana();
};

const firstNameInput = () => {
  firstNameKana.value = firstNameAutokana.getFurigana();
};

const router = useRouter();
const transitionPage = () => {
  store.commit('userRegistration/setFirstName', firstName.value);
  store.commit('userRegistration/setLastName', lastName.value);
  store.commit('userRegistration/setFirstNameKana', firstNameKana.value);
  store.commit('userRegistration/setLastNameKana', lastNameKana.value);
  router.push({ name: 'b04' });
};
const transitionPreviousPage = () => {
  router.push({ name: 'b00' });
};

onBeforeMount(async () => {
  const token = store.getters['userRegistration/token'] as string;
  if (!token) {
    router.push({ name: 'b11' });
    return;
  }
});
alertOnReload();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Indicator, {
          current: 5,
          max: 8
        })
      ]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(BaseTextForm, {
              name: "lastName",
              id: "lastName",
              modelValue: _unref(lastName),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(lastName) ? (lastName).value = $event : null)),
              placeholder: "姓",
              maxlength: 50,
              isError: !!_unref(errors).lastName,
              onInput: lastNameInput
            }, null, 8, ["modelValue", "isError"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(BaseTextForm, {
              name: "firstName",
              id: "firstName",
              modelValue: _unref(firstName),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(firstName) ? (firstName).value = $event : null)),
              placeholder: "名",
              maxlength: 50,
              isError: !!_unref(errors).firstName,
              onInput: firstNameInput
            }, null, 8, ["modelValue", "isError"])
          ])
        ]),
        (_unref(errors).lastName || _unref(errors).firstName)
          ? (_openBlock(), _createBlock(ErrorMessage, {
              key: 0,
              errors: [_unref(nameErrors)]
            }, null, 8, ["errors"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(BaseTextForm, {
              name: "lastNameKana",
              id: "lastNameKana",
              modelValue: _unref(lastNameKana),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(lastNameKana) ? (lastNameKana).value = $event : null)),
              placeholder: "セイ",
              maxlength: 50,
              isError: !!_unref(errors).lastNameKana
            }, null, 8, ["modelValue", "isError"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(BaseTextForm, {
              name: "firstNameKana",
              id: "firstNameKana",
              modelValue: _unref(firstNameKana),
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(firstNameKana) ? (firstNameKana).value = $event : null)),
              placeholder: "メイ",
              maxlength: 50,
              isError: !!_unref(errors).firstNameKana
            }, null, 8, ["modelValue", "isError"])
          ])
        ]),
        (_unref(errors).lastNameKana || _unref(errors).firstNameKana)
          ? (_openBlock(), _createBlock(ErrorMessage, {
              key: 0,
              errors: [_unref(nameKanaErrors)]
            }, null, 8, ["errors"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(BaseButton, {
            onClick: transitionPreviousPage,
            theme: "tertiary",
            type: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("戻る")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(BaseButton, {
            onClick: transitionPage,
            theme: "primary",
            type: "button",
            disabled: !_unref(meta).valid
          }, {
            default: _withCtx(() => [
              _createTextVNode("次へ")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ])
  ]))
}
}

})